module.exports = __webpack_public_path__ + "static/lightning-lookup-7314143e4e3032570599c2d370fb98d1.png";